/**
 * The tab on a side panel's outer edge that folds it away and brings it back.
 * It sits on the edge facing the canvas, so it stays in the same place whether
 * the panel is open or folded to nothing, and its caret points the way the
 * panel will move.
 */
import { PanelCaretLeftIcon, PanelCaretRightIcon } from "../icons";

export function PanelTab({
  side,
  open,
  name,
  onToggle,
}: {
  /** Which side of the canvas the panel is on. */
  side: "left" | "right";
  open: boolean;
  /** What the panel is, for the button's name: "palette", "inspector". */
  name: string;
  onToggle: () => void;
}) {
  const label = `${open ? "Hide" : "Show"} ${name}`;
  // A left panel folds leftwards; a right one rightwards.
  const pointsLeft = side === "left" ? open : !open;
  return (
    <button
      type="button"
      className={`ws-panel-tab ws-panel-tab-${side}`}
      aria-expanded={open}
      aria-label={label}
      title={label}
      onClick={onToggle}
    >
      {pointsLeft ? <PanelCaretLeftIcon /> : <PanelCaretRightIcon />}
    </button>
  );
}
